import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractService } from './abstract.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EstadoService extends AbstractService {

    constructor(public http: HttpClient) {
        super('v1/localidade', http);
    }

    async recuperarTodas(): Promise<Array<any>> {
        return this.getAll('ufs').toPromise();
    }

    async recuperarTodasUser(): Promise<Array<any>> {
        return this.getAll('user/ufs').toPromise();
    }


}
